export default "__VITE_ASSET__BUh8Tz9z__"